import * as React from 'react';
import { EventSelector } from '../../molecules/forms/EventSelector';
import { LoaderRow } from '../../atoms/layout/LoaderRow';
import { EventListPane } from '../../molecules/events/EventListPane';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { observer } from 'mobx-react';
import './allEventSection.module.scss';
import { RemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { SheLocation } from '../../../types/location';
import { EventListState } from './states/EventListState';
import { CurrentUserState, FlagKeys } from '../../../../mainv2/states/CurrentUserState';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { V2Routes } from '../../../../mainv2/routes';
import { V3Routes } from '../../../routes';
import { routingStore } from '../../../../common/stores/routing';
import { PageHeader } from '../../atoms/layout/PageHeader';
import { SectionHeader } from '../../atoms/layout/SectionHeader';

type Props = {
  currentUser: CurrentUserState;
  eventList: EventListState;
  locations: RemoteResourceV3<SheLocation[]>;
};

export const AllEventSection = observer(({ currentUser, eventList, locations }: Props) => {
  const {
    selectedLocationSelectors,
    setSelectedLocationSelectors,
    setSelectedCategoryTagSelectors,
    setSelectedAttributeTagSelectors,
    loading,
    selectedCategoryTagSelectors,
    selectedAttributeTagSelectors,
    uiFlags,
    toggleUiFlag,
  } = eventList;

  const isShowCarousel = currentUser.hasEnabledFlagKey(FlagKeys.SHOW_CAROUSEL_IN_EVENT_PAGE);

  return (
    <div styleName="section">
      {isShowCarousel ? (
        <SectionHeader title="ALL EVENT" subTitle="開催予定の全てのイベント" />
      ) : (
        <>
          <PageHeader title="EVENT" testId="page-header-of-events" />
        </>
      )}
      <div styleName="header">
        <EventSelector
          locations={locations.getOrElse([])}
          homeLocationId={currentUser.homeLocation.locationId}
          showOnline={true}
          showOnlineFirst={true}
          isHomeLocationSet={currentUser.homeLocation.isHomeLocationSet}
          isOpen={uiFlags.eventsSelectorOpen}
          condition={{
            locations: selectedLocationSelectors,
            categories: selectedCategoryTagSelectors || [],
            attributes: selectedAttributeTagSelectors || [],
          }}
          onChangeLocations={setSelectedLocationSelectors}
          onChangeCategories={setSelectedCategoryTagSelectors}
          onChangeAttributes={setSelectedAttributeTagSelectors}
          onToggle={() => toggleUiFlag('eventsSelectorOpen')}
        />
      </div>

      {loading ? (
        <LoaderRow />
      ) : (
        <>
          <EventListPane
            events={uiFlags.eventsMore ? eventList.filteredEvents : eventList.filteredEvents.slice(0, 6)}
            onItemClick={(ev) =>
              GlobalStatesV3.routing.push(
                GlobalStatesV3.currentUser.hasEnabledFlagKey(FlagKeys.REDIRECT_EVENT_DETAIL_PAGE)
                  ? V2Routes.eventDetailsPage(ev.id)
                  : V3Routes.DynamicPath.openEventOverlay(routingStore.location, ev.id)
              )
            }
          />
          {!uiFlags.eventsMore && (
            <section styleName="more-button-container">
              <Button type="primary" size="m" onClick={() => toggleUiFlag('eventsMore')}>
                すべてのイベントを表示
              </Button>
            </section>
          )}
        </>
      )}
    </div>
  );
});
